import { getBaseUrl } from '../utils/getBaseUrl'; 

const baseURL = getBaseUrl() + 'tags/';

export const DeleteTags = async (recordId) => {
    try {
        await fetch(baseURL + 'delete', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: recordId
        });
        return "Deleted Tags";
    } catch (error) {
        console.error('Error deleting the tags:', error);
    }
};

export const GetAllTags = async () => {
    try {
        const response = await fetch(baseURL + 'getall', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching all records:', error);
    }
};

export const GetTagsById = async (recordId) => {
    try {
        const response = await fetch(baseURL + `getbyid?pk=${recordId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error(`Error fetching record by ID (${recordId}):`, error);
    }
};

export const AddTags = async (recordBody) => {
    try {
        await fetch(baseURL + 'add', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: recordBody
        });
        return "Record added";
    } catch (error) {
        console.error('Error adding record:', error);
    }
};
